import React from "react";
import Manager from "./manager";
import TagValuesList from "./tag-values";

const TagManager = ({ contextType, contextId, isResource }) => {
  return (
    <Manager>
      <TagValuesList contextId={contextId} contextType={contextType} isResource={isResource} />
    </Manager>
  );
};

export default TagManager;



// WEBPACK FOOTER //
// ./src/components/tags-manager/index.js